<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item label="Account Name">
              <a-input  v-model="queryParam.mobileNo"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="Department">
              <a-select v-model="queryParam.department" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
<!--                <a-select-option value="">All</a-select-option>-->
                <a-select-option v-for='item in departments' :key='item.value'>
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="Group">
              <a-select v-model="queryParam.group" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
<!--                <a-select-option value="">All</a-select-option>-->
                <a-select-option v-for='item in groups' :key='item.value'>
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="Stage">
              <a-select v-model="queryParam.stage" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
<!--                <a-select-option value="">All</a-select-option>-->
                <a-select-option v-for='item in stages' :key='item.value'>
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="CollectorStatus">
              <a-select v-model="queryParam.status" :placeholder="$t('select')" style="width: 100%" :allowClear='allowClear'>
<!--                <a-select-option value="">All</a-select-option>-->
                <a-select-option v-for='item in statuses' :key='item.value'>
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>

        </a-row>
        <a-row>
          <a-col>
            <a-col :span="6" :sm="8">
              <a-form-item :label="'Date'">
                <a-range-picker
                  v-model="queryParam.dataDt"
                  format="YYYY-MM-DD"
                  style="width: 100%;"/>
              </a-form-item>
            </a-col>

            <a-col :span="6" :sm="8">
              <a-form-item label="Transaction Type" style="margin-left: 10px">
                <a-select v-model="queryParam.type" >
                  <a-select-option :key='0'>
                    Withdrawal
                  </a-select-option>
                  <a-select-option :key='1'>
                    Salary
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="downLoadData()" icon="download" style="margin-left: 8px">Export Salary Flow</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
        <span slot="action" slot-scope="text, record">
          <a @click="tiXianMingXi(record)">
            Withdrawal Details
          </a>
          <a @click="shouRuMingXi(record)">
            Income Details
          </a>
          <a @click="updateAccount(record)">
            Modify
          </a>
        </span>

      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>

      <v-modal
        v-model="visible1"
        title="Withdrawal Details"
        >
        <div style="padding: 20px;">
          <v-flow-module
            v-if="visible1"
            :mobile-no="flowInfo.mobileNo"
            :flow-type="flowInfo.flowType"
            @close="visible1 = false;"/>
        </div>
      </v-modal>

      <v-modal
        v-model="visible2"
        title="Received Details">
        <div style="padding: 20px;">
          <v-flow-module
            v-if="visible2"
            :mobile-no="flowInfo.mobileNo"
            :flow-type="flowInfo.flowType"
            @close="visible2 = false;"/>
        </div>
      </v-modal>
      <v-account-update-module ref="collectionUserAccountUpdate" @ok="modalFormOk" ></v-account-update-module>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import vFlowModule from './modules/CollectionAccountTradeFlowModule'
import vAccountUpdateModule from './modules/CollectionUserAccountUpdateModule'
import { collectionUserAccountList,baseData } from '@/webpublicapi/CollectionAccountInfo'
import vModal from '@/views/webpublic/modules/Modal'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment/moment'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  components: {vModal, vFlowModule, vAccountUpdateModule },
  data () {
    return {
      I18N_KEY,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      allowClear: true,
      dataSource: [],
      // Query conditions
      queryParam: {
        dataDt: [moment(new Date).add(-31, 'days'), moment(new Date)],
        mobileNo: null,
        status: null,
        stage: [],
        group: [],
        department: [],
        type: 0
      },
      loading: false,
      statuses: [{"label":"Enable", "value":"1"},{"label":"Disable", "value":"2"}],
      departments: [],
      groups: [],
      stages: [],
      visible1: false,
      visible2: false,
      flowInfo:{
        mobileNo:"",
        flowType: null
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: "Account",
          align: 'left',
          dataIndex: 'mobile'
        },{
          title: "Name",
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: "Surname",
          align: 'left',
          dataIndex: 'surnames'
        },
        {
          title: "ID CardNo.",
          align: 'left',
          dataIndex: 'curp'
        },
        {
          title: "Phone",
          align: 'left',
          dataIndex: 'phoneNo'
        },
        {
          title: "Bank CardNo.",
          align: 'left',
          dataIndex: 'bankCardNo'
        },
        {
          title: "Balance",
          align: 'left',
          dataIndex: 'balAmt'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  created () {
    this.loadBaseData();
  },
  methods: {
    loadBaseData() {
      baseData({}).then((res) => {
        if (res.code === 1000) {
          this.departments = res.data.departments
          this.groups = res.data.groups
          this.stages = res.data.stages
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    searchQuery () {
      this.loadData(1)
    },
    tiXianMingXi(record) {
      this.flowInfo.mobileNo = record.mobile;
      this.flowInfo.flowType = 0;
      this.visible1 = true;
    },
    shouRuMingXi(record) {
      this.flowInfo.mobileNo = record.mobile;
      this.flowInfo.flowType = 1;
      this.visible2 = true;
    },
    updateAccount(record) {
      this.$refs.collectionUserAccountUpdate.edit(record);
      this.$refs.collectionUserAccountUpdate.title = 'Edit Account Info';
    },
    modalFormOk () {
      this.loadData();
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      collectionUserAccountList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    downLoadData () {
      var params = this.getQueryParams()// Query conditions
      var fileUrlUrl = '/api/web/webpublic/collectionUserAccountInfo/exportAccountFlowExcel?beginCreateTime=' + params.startDate + '&endCreateTime=' + params.endDate + '&type=' + params.type;
      if (params.department && params.department.length > 0) {
        fileUrlUrl += '&department=' + params.department;
      }
      if (params.stage && params.stage.length > 0) {
        fileUrlUrl += '&stage=' + params.stage;
      }
      if (params.group && params.group.length > 0) {
        fileUrlUrl += '&group=' + params.group;
      }

      const file = {
        fileUrl: fileUrlUrl,
        fileName: params.type + '_' +  params.startDate + '_' + params.endDate + '.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },

    getQueryParams () {
      var dataDt = this.queryParam.dataDt;
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt;

      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum;
      param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.mobileNo = null
      that.queryParam.status = null
      that.queryParam.stage = []
      that.queryParam.group = []
      that.queryParam.department = []
      that.queryParam.flowType = 1
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
.description {
  line-height: 1.4;
  &.d_text {
    text-indent: 1em;
  }
  &.d_high_light {
    color: #fd9a38;
  }
}
</style>
